import { useEffect, useState } from 'react';
import { isProduction } from '@wise/wise-environments';

const ProdId = '4EbHKx';
const TestId = '1WxhEK'; // change as you wish in order to track
const iFrameClassName = 'wise-embedded';
const isProdEnvironment = isProduction('AAB');

const config = {
  trackingUri: `//code.etracker.com/code/e.js`,
  scriptId: '_etLoader',
  // As etracker does not provide tests keys you need to create an account
  // every 30 days and use that for non-prod env to check your work....
  accountNumber: isProdEnvironment ? ProdId : TestId,
  bodySelector: 'body',
  isLoggingEnabled: !isProdEnvironment,
};

const { trackingUri, scriptId, accountNumber } = config;

export const ETracker = () => {
  const [title, setTitle] = useState(document.title);
  const [isInIframe, setInIFrame] = useState<true | false | undefined>(
    undefined
  );

  useEffect(() => {
    setInIFrame(document.body.className.includes(iFrameClassName));
  }, []);

  const injectScript = () => {
    const eTrackerTag = window.document.getElementById(scriptId);
    if (eTrackerTag || isInIframe) {
      return;
    }
    const utag = window.document.createElement('script');
    utag.id = scriptId;
    utag.charset = 'UTF-8';
    utag.setAttribute('data-block-cookies', 'true');
    utag.setAttribute('data-secure-code', accountNumber);
    utag.setAttribute('data-page-changed-detection', 'title');
    utag.src = `${trackingUri}`;
    utag.type = 'text/javascript';
    utag.async = true;
    window.document.head.appendChild(utag);
  };

  const onTitleChange = (et_pagename: string) => {
    if (
      et_pagename !== title &&
      et_pagename !== 'undefined' &&
      et_pagename !== undefined
    ) {
      injectScript();
      setTitle(et_pagename);
    }
  };

  useEffect(() => {
    const titleElement = document.querySelector('title');

    const observer = new MutationObserver(() => onTitleChange(document.title));
    if (titleElement) {
      observer.observe(titleElement, { childList: true });
    }

    return () => observer.disconnect();
  }, []);

  return null;
};
